
export default {

    search: function(params = {}){
        return window.axios.get('/api/emails-templates/search', {
            params: params,
        });
    },

    get: function (id) {
        return window.axios.get('/api/emails-templates/'+id);
    },

    update: function (template) {
        return window.axios.put('/api/emails-templates/'+template.id, template);
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/services/EmailTemplatesService.js